/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import PinKeyboard from '../components/keyboard/PinKeyboard';
import {unlockUser} from '../../common/users/actions';

class PinSwitchLogin extends React.Component {

    static propTypes = {
        unlockUser: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(pin) {
        const {unlockUser} = this.props;
        unlockUser(pin);
    }

    render() {
        return (
            <PinKeyboard onSubmit={this.onFormSubmit} showButtonLoginByPassword={false}/>
        );
    }
}

export default connect(state => ({

}), {unlockUser})(PinSwitchLogin);


// WEBPACK FOOTER //
// ./src/browser/login/PinSwitchLogin.js